import { render, staticRenderFns } from "./m-action-chip.vue?vue&type=template&id=ddfd5b4c&scoped=true&"
import script from "./m-action-chip.vue?vue&type=script&lang=js&"
export * from "./m-action-chip.vue?vue&type=script&lang=js&"
import style0 from "./m-action-chip.vue?vue&type=style&index=0&id=ddfd5b4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd5b4c",
  null
  
)

export default component.exports